function parseCoordinate(value, minimum, maximum, label) {
  if (value === undefined || value === null ||
      (typeof value === "string" && !value.trim())) {
    return { valid: true, absent: true, value: "" };
  }
  if (typeof value !== "string" && typeof value !== "number") {
    return { valid: false, error: `${label} deve ser um número entre ${minimum} e ${maximum}.` };
  }

  let normalized = typeof value === 'number'
    ? value.toLocaleString('en-US', { useGrouping: false, maximumSignificantDigits: 21 })
    : value.trim();
  if (normalized.includes(",")) {
    if (normalized.includes(".") || (normalized.match(/,/g) || []).length !== 1) {
      return { valid: false, error: `${label} deve ser um número entre ${minimum} e ${maximum}.` };
    }
    normalized = normalized.replace(",", ".");
  }
  if (!/^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/.test(normalized)) {
    return { valid: false, error: `${label} deve ser um número entre ${minimum} e ${maximum}.` };
  }

  const coordinate = Number(normalized);
  if (!Number.isFinite(coordinate) || coordinate < minimum || coordinate > maximum) {
    return { valid: false, error: `${label} deve ser um número entre ${minimum} e ${maximum}.` };
  }
  return { valid: true, absent: false, value: normalized.replace(/^\+/, '') };
}

export function validateCoordinatePair(latitude, longitude, { required = true } = {}) {
  const parsedLatitude = parseCoordinate(latitude, -90, 90, "Latitude");
  const parsedLongitude = parseCoordinate(longitude, -180, 180, "Longitude");
  const errors = {};

  if (!parsedLatitude.valid) errors.latitude = parsedLatitude.error;
  if (!parsedLongitude.valid) errors.longitude = parsedLongitude.error;
  if (parsedLatitude.absent && (required || !parsedLongitude.absent)) errors.latitude = "Latitude: informe um valor em graus decimais entre -90 e 90.";
  if (parsedLongitude.absent && (required || !parsedLatitude.absent)) errors.longitude = "Longitude: informe um valor em graus decimais entre -180 e 180.";

  return {
    valid: Object.keys(errors).length === 0,
    errors,
    latitude: parsedLatitude.value,
    longitude: parsedLongitude.value,
  };
}
